<template>
  <div class="core">
        <div class="layui-fluid">
            <div>
                <div class="layui-form layui-card-header layuiadmin-card-header-auto">
                    <div class="layui-form-item">
                        <div class="layui-inline">
                            权限名称
                        </div>
                        <div class="layui-inline">
                            <input class="layui-input"  autocomplete="off"  placeholder="请输入权限名称" v-model="t_auth.queryObject['FUNCTIONNAME:2']">
                        </div>
                        <div class="layui-inline">
                            权限标签
                        </div>
                        <div class="layui-inline">
                            <input class="layui-input"  autocomplete="off"  placeholder="请输入权限标签" v-model="t_auth.queryObject['FUNCTIONMARK:2']">
                        </div>
                        <div class="layui-inline">
                            描述
                        </div>
                        <div class="layui-inline">
                            <input class="layui-input"  autocomplete="off"  placeholder="请输入描述信息" v-model="t_auth.queryObject['FUNCTIONDEC:2']">
                        </div>
                       <div class="layui-inline">
                            <button class="layui-btn layuiadmin-btn-list" @click="$refs.t_auth.search()" title="查询">查询</button>
                            <button class="layui-btn" @click="$refs.t_auth.reset()" title="重置">重置</button>
                        </div>
                    </div>
                </div>
                <div class="layui-card-body">
                    <div class="ywpt-btn">
                        <button class="layui-btn layuiadmin-btn-role"
                            @click="$refs.authForm.open('添加根节点',800, 600);
                            $refs.authForm.setDefaultValue('JB',1).setDefaultValue('PID', -1).setDefaultValue('PARENT_FUNCTION', null);
                            $refs.authForm.setEditRow();">
                            添加
                        </button>
                    </div>
                    <div class="layui-table-body layui-table-main">
                        <layui-tabletree
                            ref="t_auth"
                            :expand-level = "1"
                            table-name="DB_FUNCTION"
                            show-field="FUNCTIONNAME"
                            treeid = "FUNCTIONID"
                            treepid = "PID"
                            jb-field="JB"
                            :default-condition="{'JB': '1'}"
                            :sort="['FUNCTIONID:ASC']"
                            :page-size="25"
                            :page-range="6"
                            :page-options="[15, 25, 50, 100]"
                            @tabletree-event-addchild="addchild($event.data)"
                            @tabletree-event-treeedit="treeEdit($event.data)"
                            @tabletree-event-treedel="treeDel($event.data)"
                            height="full-270">
                            <div>
                                <div field="FUNCTIONNAME" title="权限名称" align="center"></div>
                                <div field="FUNCTIONMARK" title="权限标签" align="center"></div>
                                 <div field="FUNCTIONADDRESS" title="权限url" align="center"></div>
                                <div field="JB" title="级别" align="center"></div>
                                <div field="FUNCTIONDEC" title="描述" align="center"></div>
                                <div field="_opt" align="center"  title="操作" width="180">
                                    <script type="text/html">
                                        <a class="layui-btn-xs" lay-event="addchild">新增下级</a>
                                        <a class="layui-btn-xs"  lay-event="treeedit">编辑</a>
                                        <a class="layui-btn-xs" lay-event="treedel">删除</a>
                                    </script>
                                </div>
                            </div>
                        </layui-tabletree>
                    </div>
                </div>
            </div>
        </div>
        <layui-form ref="authForm" :after-save = "treeAfterSave">
                <template slot-scope="{scope}">
                    <div class="layui-form"  style="padding: 20px 30px 0 0;">
                         <div class="layui-form-item" v-if="scope.editRow.PARENT_FUNCTION">
                            <label class="layui-form-label">上级权限：</label>
                            <div class="layui-input-inline">
                                <input type="text" v-model="scope.editRow.PARENT_FUNCTION"  autocomplete="off" class="layui-input" disabled="disabled" style="width:300px">
                            </div>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label"> <span class="x-red">*</span>权限名称：</label>
                            <div class="layui-input-inline">
                                <input type="text" v-model="scope.editRow.FUNCTIONNAME"  autocomplete="off" class="layui-input" name="FUNCTIONNAME" style="width:300px">
                            </div>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label"> <span class="x-red">*</span>权限标签：</label>
                            <div class="layui-input-inline">
                                <input type="text" v-model="scope.editRow.FUNCTIONMARK"  autocomplete="off" class="layui-input" name="FUNCTIONMARK">
                            </div>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label"> <span class="x-red">*</span>权限url：</label>
                            <div class="layui-input-inline">
                                <input type="text" v-model="scope.editRow.FUNCTIONADDRESS"  autocomplete="off" class="layui-input" name="FUNCTIONADDRESS">
                            </div>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label"> <span class="x-red">*</span>级别：</label>
                            <div class="layui-input-inline">
                                <input type="text" v-model="scope.editRow.JB"  autocomplete="off" class="layui-input" name="JB" disabled="disabled">
                            </div>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label"> 描述：</label>
                            <div class="layui-input-inline" style="width: 70%;">
                                 <textarea placeholder="请输入描述信息"   v-model="scope.editRow.FUNCTIONDEC"
                                  class="layui-textarea"></textarea>
                            </div>
                        </div>
                        <div class="layui-form-item">
                            <label for="L_repass" class="layui-form-label"> </label>
                            <button class="layui-btn" @click="$refs.authForm.callableSave($refs.t_auth)">保存</button>
                            <button class="layui-btn" @click="$refs.authForm.close()">关闭</button>
                        </div>
                    </div>
                </template>
            </layui-form>
    </div>
</template>

<script>
export default {
  name: 'Auth',
  data () {
    return {
       t_auth : {
            queryObject: {}
        },
    }
  },
  mounted() {
       this.t_auth = this.$refs.t_auth;
  },
  methods: {
      treeAfterSave(row, isNew) {
          var t_auth = this.$refs.t_auth;
          var authForm = this.$refs.authForm;
          var treeObjData = t_auth.getTableTreeObj().getTableTreeData();
          authForm.close();
          if(row[t_auth.jbField] == 1) {
              //根节点
              if (isNew) {
                 // 新增
                 t_auth.data.push(row);
                 treeObjData.push(row);
              } else {
                 // 编辑
                for(var i = 0 ; i < t_auth.data.length ; i++) {
                    var item =  t_auth.data[i];
                    if(item[t_auth.treeid] == row[t_auth.treeid]) {
                        t_auth.data[i] = row;
                        treeObjData[i] = row;
                        break;
                    }
                }
              }

          } else {
            // 处理非根节点
                var parent = [];
                t_auth.findNodeById(row[t_auth.treepid], t_auth.data, parent);
                var parent = parent[0];
                if(! parent.treeList )  parent.treeList  = [];
                if(isNew) {
                    // 新增
                    parent.treeList.push(row);
                } else {
                    // 编辑
                    for(var i = 0 ; i < parent.treeList.length ; i++) {
                        var item = parent.treeList[i];
                        if(item[t_auth.treeid] == row[t_auth.treeid]) {
                            parent.treeList[i] = row;
                            break;
                        }
                    }
                }

              row._p = true;
          }
           t_auth.getTableTreeObj().refresh();
      },
      addchild(row) {
          var t_auth = this.$refs.t_auth;
          this.$refs.authForm.open('添加下级节点',800, 600);
          var parentJb = row[t_auth.jbField];
          this.$refs.authForm.setDefaultValue('JB', Number(parentJb) + 1);
          this.$refs.authForm.setDefaultValue('PARENT_FUNCTION', row.FUNCTIONNAME);
          this.$refs.authForm.setDefaultValue('PID', row.FUNCTIONID);
          this.$refs.authForm.setEditRow();
      },
      treeEdit(row) {
           this.$refs.authForm.open('编辑当前节点',800, 600);
           this.$refs.authForm.setEditRow(row);
      },
      treeDel(row) {
        var t_auth = this.$refs.t_auth;
        var p2 = {};
        var pid = row[t_auth.treeid];
        p2[t_auth.treepid] = pid;
        this.api.queryList(t_auth.tableName, {p2: p2,  p9: t_auth.selectFields, p10: t_auth.sort}).then(response => {
            var result = response.result;
            if(result.length == 0){
                this.layer.openConfirm('<span style="color:red">确定要删除该节点吗?</span>', ()=> {
                    this.api.delRows(t_auth.tableName, { p5: [row]}).then(response => {
                        t_auth.getTableTreeObj().delTreeNode(pid);
                        this.layer.openSuccess('删除成功!');
                    });
                });
            } else {
                this.layer.openAlert('该节点还有子节点，不能删除！', false);
            }
        });
      }
  }
}
</script>
<style scoped>
.core .layui-table-header .layui-table-cell.laytable-cell-group{
  text-align:center;
}
</style>




// WEBPACK FOOTER //
// src/components/ywpt/auth/Auth.vue